'use es6';

import { BaseResponsiveHeaderToolbar, buildHeaderActions } from './BaseResponsiveHeaderToolbar';

/**
 * @param {string} props.responsiveSize (required)
 * @param {boolean} props.isInNonDefaultBreakpointMode (required)
 */
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileHeaderToolbar = ({
  responsiveSize,
  isInNonDefaultBreakpointMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveHeaderToolbar, {
    actions: buildHeaderActions({
      isInNonDefaultBreakpointMode
    }),
    responsiveSize: responsiveSize
  });
};

/**
 * @param {string} props.responsiveSize (required)
 */
const MockResponsiveDesktopHeaderToolbar = ({
  responsiveSize
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveHeaderToolbar, {
    actions: buildHeaderActions({}),
    responsiveSize: responsiveSize
  });
};
export { MockResponsiveDesktopHeaderToolbar, MockResponsiveMobileHeaderToolbar };